// Module
var code = `<dx-button *ngIf="this.visible" type="default" stylingMode="contained" (onClick)="this.pageOptionsPopUpService.popupControl.toggleVisibility()" style="background-color:grey"> <i class="fa-solid fa-cog"></i> </dx-button> `;
// Exports
export default code;